export const fieldClass =
  'w-full rounded-md border border-[#D1D1D1] px-3 py-2 text-sm text-[#0C0B0B] focus:outline-none focus:ring-1 focus:ring-[#3da3d4] disabled:bg-[#F5F5F5]';
export const compactSelectClass =
  'h-10 w-auto max-w-[180px] shrink-0 rounded-md border border-[#D1D1D1] bg-white px-2.5 text-sm text-[#0C0B0B] focus:outline-none focus:ring-1 focus:ring-[#3da3d4]';
export const labelClass = 'block text-[12px] font-medium text-[#626262] mb-1';
export const helperClass = 'mt-1 text-[12px] text-[#8A8A8A]';
export const primaryBtnClass =
  'h-9 px-4 rounded-md bg-[#3da3d4] text-white text-sm font-medium disabled:opacity-50';
export const secondaryBtnClass =
  'h-9 px-3 rounded-md border border-[#D1D1D1] text-sm text-[#4A4A4A] hover:bg-[#F5F5F5] disabled:opacity-50';
export const dangerBtnClass =
  'h-9 px-4 rounded-md border border-red-200 text-sm font-medium text-red-700 hover:bg-red-50 disabled:opacity-50';
export const pillActive = 'bg-[#0C0B0B] text-white';
export const pillInactive = 'bg-[#F3F3F3] text-[#4A4A4A] hover:bg-[#E8E8E8]';
